import { POST_WITH_ID } from '@brickwise/asset-validation';
import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NormalDatepicker } from 'src/components/mui-overrides/Datepicker';

interface Props {
  disabled?: boolean;
}

export const IssueEndDatePicker: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext<POST_WITH_ID>();

  return (
    <NormalDatepicker
      disabled={disabled}
      label={t('dashboard.assets.addedit.investment.issuingdetails.fields.enddate')}
      fieldName="investmentDetails.issueEndDate"
      formik={formik}
    />
  );
};
